import React from 'react'
import './About.css'

function About() {

    /* copied from Nav */
    const Mailto = ({ email, subject = '', body = '', children }) => {
        let params = subject || body ? '?' : '';
        if (subject) params += `subject=${encodeURIComponent(subject)}`;
        if (body) params += `${subject ? '&' : ''}body=${encodeURIComponent(body)}`;

        return <a href={`mailto:${email}${params}`}>{children}</a>;
      };

    return (
        <div className="about">
            <div className="about-content">
                <h2>about-me:$<span className="blinking-cursor">|</span></h2>
                <p>My name is Corey and I love helping people and companies develop solutions to their digital problems. I find that working with both the front and back side of things help me see the whole picture and allows me to fine tune issues however we need.
                </p>
                <p>
                    I'm not a wizard and I'm not a genius. I'm just a guy that enjoys solving problems to help others. The real world is already difficult enough to navigate, let me help make the digital world a little less complicated.
                </p>
                <div className="skills-section">
                    <h3>Technologies Used</h3>
                    <ul>
                        <li>
                            <img
                            src="https://camo.githubusercontent.com/8915cd5de77c2e89b8523d6a01640ef3065af22420778fe27fab69427d73c876/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f48544d4c352d4533344632363f6c6f676f3d68746d6c35266c6f676f436f6c6f723d7768697465266c6f676f57696474683d3230"
                            />
                        </li>
                        <li>
                            <img
                            src="https://camo.githubusercontent.com/a3455b86cf448b3d24b6227837c02ac264cd80e2a6889e1aef3b955a4d6a73a7/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f435353332d3135373242363f6c6f676f3d63737333266c6f676f436f6c6f723d7768697465266c6f676f57696474683d3230"
                            />
                        </li>
                        <li>
                            <img
                            src="https://camo.githubusercontent.com/0cd0eecfd8e8e32bd3e3003bba0fa3c72450c160ce9fb7ce8d40385bd9d0f271/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f4a6176615363726970742d4637444631452e7376673f6c6f676f3d6a617661736372697074266c6f676f436f6c6f723d626c61636b266c6f676f57696474683d3230"
                            />
                        </li>
                        <li>
                            <img
                            src="https://camo.githubusercontent.com/942d244f87ed905c7bd5b46799ce4983a16fa4f6d358c9b94f0d0235f228b5d1/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f52656163742d3230323332413f6c6f676f3d7265616374266c6f676f436f6c6f723d363144414642266c6f676f57696474683d3230"
                            />
                        </li>
                        <li>
                            <img
                                src="https://camo.githubusercontent.com/8ef1b30beb5f52c80c5eb263ec4fd8ee698871713d2bf470e12b35ef5f4312ef/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f5675654a532d3335343935452e7376673f6c6f676f3d7675652e6a73266c6f676f57696474683d3230"
                            />
                        </li>
                        <li>
                            <img
                                src="https://camo.githubusercontent.com/aa38b8c47378a1ad2877c67bbd0562ff31b48e12e6534f20a5ee19bf6eab5711/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f4d6174657269616c2d2d55492d3030383143422e7376673f6c6f676f3d6d6174657269616c2d7569266c6f676f57696474683d3230"
                            />
                        </li>
                        <li>
                            <img
                                src="https://camo.githubusercontent.com/b72fe253d5ba0435f00e22c49bd8a3d8d3b4eca6fb44b0b06d45cc7afcd54328/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f5374796c65642d436f6d706f6e656e74732d4442373039332e7376673f6c6f676f3d7374796c65642d636f6d706f6e656e7473266c6f676f57696474683d3230"
                            />
                        </li>
                        <li>
                            <img
                                src="https://camo.githubusercontent.com/bec89b7738272d43fd8e7f69ab3e03e2e733bfcf8c6cbf51465a3d4dab208f2b/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f5461696c77696e642d6663663766372e7376673f6c6f676f3d7461696c77696e64637373266c6f676f57696474683d3230"
                            />
                        </li>
                        <li>
                            <img
                                src="https://camo.githubusercontent.com/e48968d009a2c21fbbe7dd0e1d70fca990ba5e3b0808420e43f96d49652520a9/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f4e6578744a532d3230323332412e7376673f6c6f676f3d6e6578742e6a73266c6f676f436f6c6f723d6e6578742e6a73266c6f676f57696474683d3230"
                            />
                        </li>
                        <li>
                            <img
                                src="https://camo.githubusercontent.com/d0fb14fb73986440240b568419bf47cc2a6520d9b7f97903915389055cdc251b/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f547970655363726970742d3030374143432e7376673f6c6f676f3d74797065736372697074266c6f676f436f6c6f723d7768697465266c6f676f57696474683d3230"
                            />
                        </li>
                        <li>
                            <img
                                src="https://camo.githubusercontent.com/c13ce979cf92eef84b0535067ad7bb969d7a069ef415aa11654fd759e4bd2330/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f4e6f64654a532d41433135312e7376673f6c6f676f3d6e6f64656a73266c6f676f57696474683d3230"
                            />
                        </li>
                        <li>
                            <img
                                src="https://camo.githubusercontent.com/5bebb2e57567a5bb036a784c249b4b992da2de053420d9dc092c582274c682b3/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f457870726573732d3430344435392e7376673f6c6f676f3d65787072657373266c6f676f57696474683d3230"
                            />
                        </li>
                        <li>
                            <img
                                src="https://camo.githubusercontent.com/2a6ac95413a482f5faa1088531133077bb6dc27a9c5ec356a59a6309d6208786/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f46697265626173652d6663663766372e7376673f6c6f676f3d6669726562617365266c6f676f57696474683d3230"
                            />
                        </li>
                        <li>
                            <img
                                src="https://camo.githubusercontent.com/0d205ac0ab32eb1d3e1dced6184d16bac514ee1de6d95e4c4e2aa47f880d0a99/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f4d6f6e676f44422d3445413934423f6c6f676f3d6d6f6e676f6462266c6f676f436f6c6f723d7768697465266c6f676f57696474683d3230"
                            />
                        </li>
                        <li>
                            <img
                                src="https://camo.githubusercontent.com/6d3b11c43812524061bdcd6b901a10d0d69d10779487a2670bcfe41cd1b08f27/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f4772617068514c2d3137316532362e7376673f6c6f676f3d6772617068716c266c6f676f436f6c6f723d653030303937266c6f676f57696474683d3230"
                            />
                        </li>
                        <li>
                            <img
                                src="https://camo.githubusercontent.com/631490704fdeb33edce71408fa4d3749b9a2db76010fbd68a6643a46a85ef504/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f4769742d6663663766372e7376673f6c6f676f3d676974266c6f676f57696474683d3230"
                            />
                        </li>
                        <li>
                            <img
                                src="https://camo.githubusercontent.com/ac7051fde122b73d5d0b425efa53b8c2a0fb7ad275a555a293724bb17b4e2d13/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f4769744875622d3130303030303f6c6f676f3d676974687562266c6f676f436f6c6f723d7768697465266c6f676f57696474683d3230"
                            />
                        </li>
                        <li>
                            <img
                                src="https://camo.githubusercontent.com/2da40ec97f2e894b9fba1b865dd2330df0d653b7b92e27c7c431173f1f7da295/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f507974686f6e2d3134333534433f6c6f676f3d707974686f6e266c6f676f436f6c6f723d7768697465266c6f676f57696474683d3230"
                            />
                        </li>
                    </ul>
                </div>

            </div>

            <div className="contact-content">
                <h2>contact-me:$<span className="blinking-cursor">|</span></h2>
                <p>You can contact me at the email below</p>
                <Mailto
                    email="corey.w.calhoun@gmail.com"
                    subject="I am looking for a developer..."
                    body=""
                >
                    corey.w.calhoun@gmail.com
                </Mailto>
            </div>
            <div hidden={true}>
               <p>
                    This site is still under development but I wanted to put something together that was simple and to the point. I will be adding a portfolio section on here along with a few other tweaks that will be made but due to time constraints, this will have to do. Thanks for stopping by and if you are interested in working together, just reach out.
                </p>
            </div>
        </div>

    )
}

export default About
